import Link from '@tiptap/extension-link'

export const CustomLink = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),

      href: {
        default: null,
        parseHTML: element => element.getAttribute('href'),
        renderHTML: attributes => ({
          href: attributes.href,
        }),
      },

      popupid: {
        default: null,
        parseHTML: element => element.getAttribute('popupid'),
        renderHTML: attributes =>
          attributes.popupid ? { popupid: attributes.popupid } : {},
      },
    }
  },
  addCommands() {
    return {
      ...this.parent?.(),

      setLink:
        (attributes: {
          href: string
          target?: string | null
          rel?: string | null
          class?: string | null
          popupid?: string | null
        }) =>
        ({ chain }) => {
          return chain().setMark(this.name, attributes).run()
        },

      toggleLink:
        (attributes: {
          href: string
          target?: string | null
          rel?: string | null
          class?: string | null
          popupid?: string | null
        }) =>
        ({ chain }) => {
          return chain().toggleMark(this.name, attributes).run()
        },

      unsetLink:
        () =>
        ({ chain }) => {
          return chain().unsetMark(this.name).run()
        },
    }
  },
  renderHTML({ mark, HTMLAttributes }) {
    const { popupid } = mark.attrs
    return [
      'a',
      {
        ...HTMLAttributes,
        popupid: popupid || null,
        style: 'cursor: pointer ',
      },
      0,
    ]
  },
})
